<button class="lt-md-hide" mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="clearFilters.emit()" [matTooltip]="'Clear All Filters'">
        <mat-icon>clear</mat-icon>
        Clear
    </button>
    @if (!isSpecSchedule) {
        <div mat-menu-item>
            <mat-slide-toggle
                name="listViewToggle"
                [ngModel]="listViewEnabled"
                (ngModelChange)="listViewEnabledChange.emit($event)"
            >
                List View
            </mat-slide-toggle>
        </div>
    }
    @if (isIncompleteOnly !== undefined) {
        <div mat-menu-item>
            <mat-slide-toggle
                name="isIncompleteOnly"
                [ngModel]="isIncompleteOnly"
                (ngModelChange)="isIncompleteOnlyChange.emit($event)"
            >
                Incomplete Items Only
            </mat-slide-toggle>
        </div>
    }
</mat-menu>
